import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Account, LoggedInUser } from '@legacy-models/portal/Account';
import { SessionAuth } from '@legacy-models/auth/user';

@Injectable({
  providedIn: 'root'
})
export class Storage {
  currentSearchFormSource = new BehaviorSubject<FormGroup | null>(null);
  currentDownloadFormSource = new BehaviorSubject<FormGroup | null>(null);
  currentUserSource = new BehaviorSubject<SessionAuth | null>(null);
  currentPageSource = new BehaviorSubject<string | null>(null);
  currentAccountSource = new BehaviorSubject<Account | null>(null);
  myAccountsSource = new BehaviorSubject<Account[] | null>(null);
  loggedInUserSource = new BehaviorSubject<LoggedInUser | null>(null);
  version = new BehaviorSubject<string | null>(null);
  searchForm$ = this.currentSearchFormSource.asObservable();
  downloadForm$ = this.currentDownloadFormSource.asObservable();
  currentPage$ = this.currentPageSource.asObservable();
  currentUser$ = this.currentUserSource.asObservable();
  currentAccount$ = this.currentAccountSource.asObservable();
  myAccounts$ = this.myAccountsSource.asObservable();
  loggedInUser$ = this.loggedInUserSource.asObservable();
  version$ = this.version.asObservable();

  getCurrentUser(): Observable<SessionAuth | null> {
    return this.currentUser$.pipe(take(1));
  }

  setCurrentSearchFormCache(searchForm: FormGroup): void {
    this.currentSearchFormSource.next(searchForm);
  }

  setCurrentDownloadFormCache(downloadForm: FormGroup): void {
    this.currentDownloadFormSource.next(downloadForm);
  }

  setCurrentUser(user: SessionAuth): void {
    sessionStorage.setItem('currUser', JSON.stringify(user));
    this.currentUserSource.next(user);
  }

  setloggedInUser(user: LoggedInUser): void {
    const logUser = JSON.parse(sessionStorage.getItem('loggedInUser') as string);
    if (!logUser) {
      sessionStorage.setItem('loggedInUser', JSON.stringify(user));
    }
    this.loggedInUserSource.next(user);
  }

  setVersion(user: string): void {
    const logVersion = JSON.parse(sessionStorage.getItem('version') as string);
    if (!logVersion) {
      sessionStorage.setItem('version', JSON.stringify(user));
    }
    this.version.next(user);
  }

  setCurrentPage(forcedPageName = ''): void {
    const urlPath = location.pathname.split('/')[1];
    let formatetedCurrPage = urlPath.replace(/-/g, ' ');
    if (forcedPageName) {
      formatetedCurrPage = forcedPageName.replace(/-/g, ' ');
    }
    this.currentPageSource.next(formatetedCurrPage);
  }

  clearCurrentUser(): void {
    sessionStorage.removeItem('currUser');
    this.currentUserSource.next(null);
  }

  clearCurrentAccount(): void {
    sessionStorage.removeItem('currAcct');
    this.currentAccountSource.next(null);
  }

  clearLoggedInUser(): void {
    sessionStorage.removeItem('loggedInUser');
    this.loggedInUserSource.next(null);
  }

  clearVersion(): void {
    sessionStorage.removeItem('version');
    this.version.next(null);
  }

  clearCurrentSearchFormCache(): void {
    this.currentSearchFormSource.next(null);
  }

  clearCurrentDownloadFormCache(): void {
    this.currentDownloadFormSource.next(null);
  }

  clearAppStorage(): void {
    this.clearCurrentUser();
    this.clearCurrentAccount();
    this.clearLoggedInUser();
    this.clearVersion();
  }

  storeCurrentAccount(acct: Account): void {
    sessionStorage.setItem('currAcct', JSON.stringify(acct));

    this.currentAccountSource.next(acct);
  }
}
